import { render } from "./ExamEventVerification.vue?vue&type=template&id=63e2bdcb&scoped=true"
import script from "./ExamEventVerification.vue?vue&type=script&lang=js"
export * from "./ExamEventVerification.vue?vue&type=script&lang=js"

import "./ExamEventVerification.vue?vue&type=style&index=0&id=63e2bdcb&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63e2bdcb"]])

export default __exports__